export function getModels(modelIds) {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/device_types/device_model/describe',
            dataType: 'json',
            data: {
                id: modelIds,
                pagination_token: pagination_token
            }
        }).promise().then(models_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in models_json.device_type_definitions) {
                results.push({
                    id: models_json.device_type_definitions[index].id,
                    device_type: models_json.device_type_definitions[index].device_type,
                    manufacturer: models_json.device_type_definitions[index].manufacturer,
                    model: models_json.device_type_definitions[index].id,
                    text: models_json.device_type_definitions[index].name,
                    name: models_json.device_type_definitions[index].name,
                });
            }

            // Break out of this recursive loop if we've found everything
            if (models_json.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(models_json.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching models. Please try again.');
        });
    };

    return execute_query();
}